import { render, staticRenderFns } from "./HeaderInformationNavigationNcph.vue?vue&type=template&id=fad76b80&scoped=true"
import script from "./HeaderInformationNavigationNcph.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationNcph.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationNcph.vue?vue&type=style&index=0&id=fad76b80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad76b80",
  null
  
)

export default component.exports